"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CalendarRow;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _CalendarDay = _interopRequireDefault(require("./CalendarDay"));
var _CalendarPaddingDay = _interopRequireDefault(require("./CalendarPaddingDay"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _locales = require("../../utils/locales");
function CalendarRow(props) {
  return props.rowDays.map((day, index, readOnlyArray) => {
    return day.type === "day" ? /*#__PURE__*/_react.default.createElement(_CalendarDay.default, (0, _extends2.default)({}, day, {
      onClick: props.clickSelectDate,
      onMouseOver: props.hoverSelectDate,
      onMouseOut: props.hoverOffDate,
      isLoading: props.isLoading,
      key: day.date.unix(),
      row: props.row,
      language: props.language
    })) : /*#__PURE__*/_react.default.createElement(_CalendarPaddingDay.default, {
      date: day.date,
      key: day.date.unix(),
      placeInRange: day.placeInRange,
      isInRange: day.isInRange
    });
  });
}
CalendarRow.propTypes = {
  /** Array of dates with their states */
  rowDays: _propTypes.default.array.isRequired,
  /** For CalendarDay to handle clicks */
  clickSelectDate: _propTypes.default.func.isRequired,
  /** For CalendarDay to handl mouse overs */
  hoverSelectDate: _propTypes.default.func.isRequired,
  /** For CalendarDay to handl mouse outs */
  hoverOffDate: _propTypes.default.func.isRequired,
  /** Selected user Language */
  language: _propTypes.default.oneOf([_locales.locales.en, _locales.locales.es, _locales.locales.fr, _locales.locales.pt, _locales.locales.zh, _locales.locales.tl, _locales.locales.de, _locales.locales.it, _locales.locales.ko, _locales.locales.ja, _locales.locales.hi]).isRequired
};